import { useEffect, useRef, useState } from "react";

export default function DropdownButton({
    trigger,
    children,
    align = "right",
    width = 180
}) {
    const [open, setOpen] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const close = () => setOpen(false);

    return (
        <div ref={ref} style={{ position: "relative" }}>
            <div onClick={() => setOpen(!open)}>
                {trigger}
            </div>

            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "110%",
                        [align]: 0,
                        padding: '6px 3px',
                        minWidth: width,
                        zIndex: 1000,
                    }}
                    className="surface-panel text-foreground animate-in fade-in zoom-in-95 duration-150 overflow-hidden"
                >
                    {typeof children === "function"
                        ? children(close)
                        : children}
                </div>
            )}
        </div>
    );
}